"use client"

import type React from "react"
import { useEffect, useState } from "react"
import {
  Box,
  Typography,
  Button,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Chip,
  Divider,
  Select,
  MenuItem,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material"
import {
  Delete as DeleteIcon,
  Add as AddIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Inventory as InventoryIcon,
  Calculate as CalculateIcon,
  Send as SendIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Inventory2 as PackageIcon,
} from "@mui/icons-material"
import { useLocation, useHistory } from "react-router-dom"
import axios from "axios"
import { baseUrl, requestID, config, getUserData } from "../../../common/utils"
import styles from "./BOMDetailPage.module.css"
import { addBarRequest_production, addBranchRequest } from "./stock-transfer"
import { getAllProducts, getBarInventoryByBranch } from "./bomService"
import { IonContent, IonPage } from "@ionic/react"
import { getTlocations } from "../../../api/stock-transfer/stock-transfer"

interface Material {
  name: string
  product_id?: string
  quantity: number
  amount: number
  total: number
}

interface Product {
  id: string
  name: string
  price: number
  product_id: string
}

const BOMDetailPage: React.FC = () => {
  const location = useLocation()
  const { product } = (location.state as { product: Product }) || {}
  const userID = getUserData()?.user_id || ""
  const history = useHistory()
  const [productName, setProductName] = useState("")
  const [qty, setQty] = useState(0)
  const [price, setPrice] = useState(0)
  const [materials, setMaterials] = useState<Material[]>([])
  const [showSetup, setShowSetup] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [productId, setProductId] = useState<string | null>(null)
  const [bom, setBom] = useState<any>(null)
  const [bomId, setBomId] = useState<string | null>(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const [editedBomItems, setEditedBomItems] = useState<any[]>([])
  const [filteredProductMaterials, setFilteredProductMaterials] = useState<Material[]>([])
  const [isBranchDialogOpen, setIsBranchDialogOpen] = useState(false)
  const [selectedBranch, setSelectedBranch] = useState("")
  const [branches, setBranches] = useState<any[]>([])

  useEffect(() => {
    if (product) {
      setProductName(product.name)
      setPrice(product.price)
      setProductId(product.product_id)
      getBomByProduct(product.product_id)
      console.log("Productid:", product)
    }
  }, [product])

  useEffect(() => {
    fetchAllProducts()
  }, [])


      const fetchData2 = async () => {
      try {
       // setLoading(true)
        const response4 = await getTlocations()
   
        setBranches(response4.data?.data || [])
        console.log("Tlocations:", response4.data)
      } catch (error) {
        console.error(error)
  
        // setToast({
        //   open: true,
        //   message: "Failed to fetch data",
        //   severity: "error",
        // })
  
      } finally {
       // setLoading(false)
      }
    }
  
    useEffect(() => {
    //  fetchData();
      fetchData2();
    }, [])
  const fetchAllProducts = async () => {
    try {
      const res = await getBarInventoryByBranch()
     // console.log("Fetched products:", res)
     // const unfinished = res.filter((prod: any) => prod.type === "unfinished")
      setFilteredProductMaterials(res)
    } catch (err) {
      console.error("Failed to fetch products:", err)
      setError("Failed to fetch products")
    }
  }

  const handleAddMaterial = () => {
    setMaterials([...materials, { name: "", quantity: 0, amount: 0, total: 0 }])
  }

  const getBomByProduct = async (productId: string) => {
    try {
      const res = await axios.post(
        `${baseUrl()}/warehouses/getBOMsByProduct`,
        {
          finished_product_product_id: productId,
          requestID: requestID(),
        },
        config,
      )
      console.log("BOM response:", res.data.data)
      const bomData = res.data?.data || null
      setBom(bomData)
      if (bomData) {
        setBomId(bomData.bom_id)
        setQty(Number(bomData.quantity_to_produce))
        setPrice(Number(bomData.price))
        setEditedBomItems(bomData.bom_items || [])
      }
    } catch (err) {
      console.error("Failed to fetch BOM:", err)
      setError("Failed to fetch BOM")
    }
  }

  const handleMaterialChange = (index: number, field: keyof Material, value: string | number) => {
    const updated = [...materials]

    if (field === "name") {
      // When material is selected, automatically set the price
      const selectedMaterial = filteredProductMaterials.find((mat) => mat.product_id === value)

      updated[index][field] = value as string

      // Automatically fill the unit cost (amount) with the material's price
      if (selectedMaterial) {
        updated[index].amount = selectedMaterial.price
        // Recalculate total with the new price
        updated[index].total = updated[index].quantity * selectedMaterial.price
      }
    } else if (field === "quantity") {
      updated[index][field] = Number(value) as number
      // Recalculate total when quantity changes
      updated[index].total = Number(value) * updated[index].amount
    } else if (field === "amount") {
      updated[index][field] = Number(value) as number
      // Recalculate total when amount changes
      updated[index].total = updated[index].quantity * Number(value)
    }

    setMaterials(updated)
  }

  const handleDeleteMaterial = (index: number) => {
    const updated = [...materials]
    updated.splice(index, 1)
    setMaterials(updated)
  }

  const handleSubmit = async () => {
    if (
      materials.some(
        (mat) =>
          mat.name ===
          bom?.bom_items.find((item: any) => item.raw_material_product_id === mat.name)?.raw_material_product_id,
      )
    ) {
      setError("Material already exists in BOM. Please edit the existing item instead.")
      console.log("Material already exists in BOM. Please edit the existing item instead.")
      return
    }

    const payload = {
      finished_product_id: productId,
      quantity_to_produce: qty,
      price: price,
      created_by: userID,
      items: materials?.map((mat) => ({
        raw_material_id: mat.name,
        quantity_required: mat.quantity,
        unit_cost: mat.amount,
      })),
    }

    try {
      const res = await axios.post(
        `${baseUrl()}/warehouses/addBOM`,
        {
          ...payload,
          requestID: requestID(),
        },
        config,
      )
      console.log("BOM submitted:", res)
      setSuccess(true)
      getBomByProduct(productId) // Refresh BOM data
      setMaterials([]) // Clear materials after submission
      setQty(0) // Reset quantity
      setPrice(0) // Reset price
      setIsEditMode(false) // Exit edit mode if applicable
    } catch (err: any) {
      console.error("Failed to submit BOM:", err)
      setError("Failed to submit BOM")
    }
  }

  const handleSendRequisition = (bom) => {
    if (!bom || !bom.bom_id) {
      setError("No BOM data available to send requisition.")
      return
    }

    const requisitionPayload = {
      bom_id: bom.bom_id,
      product_id: productId,
      quantity_to_produce: qty,
      price: price,
      created_by: userID,
    }

    try {
      const res = addBranchRequest(requisitionPayload)
      console.log("Requisition sent:", res)
      setSuccess(true)
    } catch (error) {
      console.error("Failed to send requisition:", error)
      setError("Failed to send requisition")
    } finally {
      setShowSetup(false) // Hide setup after sending requisition
    }
  }

  const handleEditBomItem = (index: number, field: string, value: string) => {
    const updated = [...editedBomItems]
    updated[index] = {
      ...updated[index],
      [field]: field === "quantity_required" || field === "unit_cost" ? Number(value) : value,
    }

    // Recalculate total_cost
    if (field === "quantity_required" || field === "unit_cost") {
      updated[index].total_cost = updated[index].quantity_required * updated[index].unit_cost
    }
    setEditedBomItems(updated)
  }

  const handleSaveBomChanges = async () => {
    const payload = {
      bom_id: bomId,
      finished_product_product_id: productId,
      quantity_to_produce: qty,
      price: price,
      created_by: userID,
      items: editedBomItems.map((item) => ({
        id: item.id,
        raw_material_id: item.raw_material_product_id,
        quantity_required: item.quantity_required,
        unit_cost: item.unit_cost,
      })),
    }

    console.log("BOM update payload:", payload)
    try {
      const res = await axios.post(
        `${baseUrl()}/warehouses/updateBOM`,
        {
          ...payload,
          requestID: requestID(),
        },
        config,
      )
      console.log("BOM updated:", res)
      setSuccess(true)
      setIsEditMode(false)
      getBomByProduct(productId)
    } catch (err: any) {
      console.error("Failed to update BOM:", err)
      setError("Failed to update BOM")
    }
  }

  const handleSendAllRequisitions = async () => {
console.log("Selected Branch:", selectedBranch)
    setLoading(true); // Start loading

   // return;
    if (!selectedBranch) {
      setError("Please select a branch before submitting.")
      return
    }

    if (!bom || !bom.bom_id) {
      setError("No BOM data available to send requisition.")
      return
    }

    const requisitionPayload = {
      bom_id: bom.bom_id,
      product_id: productId,
      quantity_to_produce: qty,
      price: price,
      created_by: userID,
      branch_id: selectedBranch, // Added selected branch
      items: bom.bom_items.map((item: any) => ({
        raw_material_id: item.raw_material_product_id,
        quantity_required: item.quantity_required,
        unit_cost: item.unit_cost,
        total_cost: item.total_cost,
      })),
    }

    const payload = bom.bom_items.map(({ raw_material_product_id, quantity_required, unit_cost }) => ({
      unit_cost: unit_cost,
      product_id: raw_material_product_id,
      quantity: quantity_required,
      product_name: filteredProductMaterials.find((mat) => mat.product_id === raw_material_product_id)?.name || "",
    }))

    try {
      const res = await addBarRequest_production({
        narration: `Requisition for BOM of ${productName} Qty: ${qty} ${price.toLocaleString()}`,
        created_by: userID,
        bom_id: bom.bom_id,
        product_id: productId,
        quantity_to_produce: qty,
        branch_id: selectedBranch, // Added selected branch
        ...payload,
      })
      console.log("Requisition sent:", res)
          setLoading(false); // Start loading

   if (!res.data.status) {
  setError(`Insufficient stock: ${res.data.message}. Please review the BOM and try again.`);
  return;
} else {
  setSuccess(true);
}
    
      setIsBranchDialogOpen(false) // Close dialog
      setSelectedBranch("") // Reset selected branch
    } catch (error) {
      console.error("Failed to send requisition:", error)
      setError("Failed to send requisition")
    }
  }

  const handleDeleteBomItem = async (bomItemId: string, id: string) => {
    if (!productId || !bomId) return


    console.log("Deleting BOM item:", bomItemId)
    try {
      const res = await axios.post(
        `${baseUrl()}/warehouses/deleteBomDetailById`,
        {
          bom_id: bomId,
          id: id,
          finished_product_product_id: productId,
          raw_material_product_id: bomItemId,
          requestID: requestID(),
        },
        config,
      )
      console.log("Delete BOM item response:", res)
      console.log("BOM item deleted:", bomItemId)
      console.log("BOM ID:", bomId)
      console.log("Product ID:", productId)
      getBomByProduct(productId)
      setSuccess(true)
    } catch (err) {
      console.error("Failed to delete BOM item:", err)
      setError("Failed to delete BOM item")
    }
  }
  const [loading, setLoading] = useState(false);

  if (!product) {
    return (
      <IonPage className="pushDown  ">

  <Box className={styles.container}>
        <Card className={styles.noProductCard}>
          <CardContent>
            <PackageIcon className={styles.emptyStateIcon} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: "#2d3748" }}>
              No Product Data Found
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Please navigate from the setup page to view BOM details.
            </Typography>
          </CardContent>
        </Card>
      </Box>
      </IonPage>
    
    )
  }

  const totalMaterialCost = materials.reduce((sum, m) => sum + m.total, 0)
 // console.log("Filtered Product Materials:", filteredProductMaterials)

  return (
    <IonPage className="pushDown">
      <IonContent>
        <Box className={styles.container}>
          {/* Header Section */}
          <Box className={styles.header}>
            <Box className={styles.headerContent}>
              <Typography component="h1" className={styles.headerContent}>
                Bill of Materials
              </Typography>
              <Typography component="p">Managing BOM for {productName}</Typography>
            </Box>
            <Box className={styles.headerActions}>
              <Button variant="outlined" onClick={() => history.push("/folder/branchRequisition")}>
                All Requisitions
              </Button>
            </Box>
          </Box>

          {/* Product Information Card */}
          <Card className={styles.card}>
            <CardHeader
              className={styles.cardHeader}
              title={
                <Typography className={styles.cardTitle}>
                  <InventoryIcon className={styles.cardIcon} />
                  Product Information
                </Typography>
              }
              subheader={
                bom && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    There{" "}
                    {bom.bom_items?.length > 0
                      ? bom.bom_items.length === 1
                        ? `is ${bom.bom_items.length}`
                        : `are ${bom.bom_items.length}`
                      : "are no"}{" "}
                    BOM items for this product.
                  </Typography>
                )
              }
            />
            <CardContent>
              <Box className={styles.productInfoGrid}>
                <Box className={styles.infoItem}>
                  <Typography className={styles.infoLabel}>Product Name</Typography>
                  <Typography className={styles.infoValue}>{productName}</Typography>
                </Box>
                <Box className={styles.infoItem}>
                  <Typography className={styles.infoLabel}>Base Price</Typography>
                  <Typography className={styles.infoValue}>₦{price.toLocaleString()}</Typography>
                </Box>
                <Box className={styles.infoItem}>
                  <Typography className={styles.infoLabel}>Status</Typography>
                  <Chip
                    label={bom?.bom_items?.length > 0 ? "Has BOM" : "No BOM"}
                    className={`${styles.statusBadge} ${
                      bom?.bom_items?.length > 0 ? styles.statusBadgeActive : styles.statusBadgeInactive
                    }`}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* BOM Configuration Card */}
          <Card className={styles.card}>
            <CardHeader
              className={`${styles.cardHeader} ${styles.collapsibleHeader}`}
              onClick={() => setShowSetup(!showSetup)}
              title={
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography className={styles.cardTitle}>
                    <EditIcon className={styles.cardIcon} />
                    BOM Configuration
                  </Typography>
                  {showSetup ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Box>
              }
              subheader="Configure production quantities and pricing"
            />
            <Collapse in={showSetup}>
              <CardContent>
                <Box className={styles.setupGrid}>
                  <TextField
                    label="Quantity to Produce"
                    type="number"
                    value={qty}
                    onChange={(e) => setQty(Number(e.target.value))}
                    className={styles.materialInput}
                    variant="outlined"
                    fullWidth
                  />
                  <TextField
                    label="Unit Price"
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(Number(e.target.value))}
                    className={styles.materialInput}
                    variant="outlined"
                    fullWidth
                  />
                  <Box className={styles.infoItem}>
                    {/* <Typography className={styles.infoLabel}>Total Value</Typography> */}
                    <Typography className={styles.infoValue}>Total Value ₦{(qty * price).toLocaleString()}</Typography>
                  </Box>
                </Box>

                {/* Existing BOMs */}
                {bom && bom.bom_items && bom.bom_items.length > 0 && (
                  <>
                    <Divider sx={{ my: 3 }} />
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                      <Typography variant="h6" sx={{ fontWeight: 600, color: "#2d3748" }}>
                        BOM Items ({bom.bom_items.length})
                      </Typography>
                      <Box display="flex" gap={2}>
                        {!isEditMode ? (
                          <>
                            <Button
                              variant="outlined"
                              startIcon={<EditIcon />}
                              onClick={() => setIsEditMode(true)}
                              className={styles.editButton}
                            >
                              Edit BOM
                            </Button>
                            <Button
                              variant="contained"
                              startIcon={<SendIcon />}
                              onClick={() => setIsBranchDialogOpen(true)}
                              className={styles.requisitionButton}
                            >
                              Process Production
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                setIsEditMode(false)
                                setEditedBomItems(bom.bom_items) // Reset changes
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              startIcon={<SaveIcon />}
                              onClick={handleSaveBomChanges}
                              className={styles.submitButton}
                            >
                              Save Changes
                            </Button>
                          </>
                        )}
                      </Box>
                    </Box>

                    {/* BOM Items Table */}
                    <Table className={styles.table}>
                      <TableHead className={styles.tableHeader}>
                        <TableRow>
                          <TableCell className={styles.tableHeaderCell}>Material Name</TableCell>
                          <TableCell className={styles.tableHeaderCell}>Quantity Required</TableCell>
                          <TableCell className={styles.tableHeaderCell}>Unit Cost</TableCell>
                          <TableCell className={styles.tableHeaderCell}>Total Cost</TableCell>
                          <TableCell className={styles.tableHeaderCell}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(isEditMode ? editedBomItems : bom.bom_items).map((bomItem: any, index: number) => (
                          <TableRow key={bomItem.id} className={styles.tableRow}>
                            <TableCell className={styles.tableCell1}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontFamily: "monospace",
                                  fontSize: "0.75rem",
                                }}
                              >
                                {filteredProductMaterials.find(
                                  (mat) => mat.product_id === bomItem.raw_material_product_id,
                                )?.name || "N/A"}
                              </Typography>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              {isEditMode ? (
                                <TextField
                                  type="number"
                                  value={bomItem.quantity_required}
                                  onChange={(e) => handleEditBomItem(index, "quantity_required", e.target.value)}
                                  className={styles.materialInput}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                />
                              ) : (
                                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                  {Number(bomItem.quantity_required)}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              {isEditMode ? (
                                <TextField
                                  type="number"
                                  value={bomItem.unit_cost}
                                  onChange={(e) => handleEditBomItem(index, "unit_cost", e.target.value)}
                                  className={styles.materialInput}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                    InputProps={{
                                readOnly: true,
                              }}
                              // helperText="Auto-filled from material price"
                              sx={{
                                "& .MuiInputBase-input": {
                                  backgroundColor: "#f5f5f5",
                                  cursor: "not-allowed",
                                },
                              }}
                                />
                              ) : (
                                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                  ₦{Number(bomItem.unit_cost).toLocaleString()}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <Typography variant="body1" sx={{ fontWeight: 600, color: "#22543d" }}>
                                ₦
                                {Number(
                                  bomItem.total_cost || bomItem.quantity_required * bomItem.unit_cost,
                                ).toLocaleString()}
                              </Typography>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              {!isEditMode && (
                                <IconButton
                                  onClick={() => handleDeleteBomItem(bomItem.raw_material_product_id, bomItem.id)}
                                  className={styles.deleteButton}
                                  size="small"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>

                    {/* BOM Summary */}
                    <Box className={styles.summary} sx={{ mt: 2 }}>
                      <Box>
                        <Typography className={styles.summaryText}>Total BOM Cost</Typography>
                        <Typography className={styles.totalCost}>
                          ₦
                          {(isEditMode ? editedBomItems : bom.bom_items)
                            .reduce(
                              (sum: number, item: any) =>
                                sum + Number(item.total_cost || item.quantity_required * item.unit_cost),
                              0,
                            )
                            .toLocaleString()}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        Production Quantity: {qty} units
                      </Typography>
                    </Box>
                  </>
                )}
              </CardContent>
            </Collapse>
          </Card>

          {/* Materials Section */}
          <Card className={styles.card}>
            <CardHeader
              className={styles.cardHeader}
              title={
                <Typography className={styles.cardTitle}>
                  <CalculateIcon className={styles.cardIcon} />
                  Materials & Components
                </Typography>
              }
              subheader="Add and manage raw materials required for production"
              action={
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleAddMaterial}
                  className={styles.addButton}
                >
                  Add Material
                </Button>
              }
            />
            <CardContent className={styles.materialsSection}>
              {materials.length === 0 ? (
                <Box className={styles.emptyState}>
                  <CalculateIcon className={styles.emptyStateIcon} />
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#2d3748" }}>
                    No Materials Added
                  </Typography>
                  <Typography variant="body1" color="text.secondary" gutterBottom>
                    Start by adding materials required for this product
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleAddMaterial}
                    className={styles.addButton}
                  >
                    Add First Material
                  </Button>
                </Box>
              ) : (
                <Box>
                  <Table className={styles.table}>
                    <TableHead className={styles.tableHeader}>
                      <TableRow>
                        <TableCell className={styles.tableHeaderCell}>Material Name</TableCell>
                        <TableCell className={styles.tableHeaderCell}>Quantity</TableCell>
                        <TableCell className={styles.tableHeaderCell}>Unit Cost</TableCell>
                        <TableCell className={styles.tableHeaderCell}>Total</TableCell>
                        <TableCell className={styles.tableHeaderCell}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {materials?.map((mat, index) => (
                        <TableRow key={index} className={styles.tableRow}>
                          <TableCell className={styles.tableCell}>
                            <div key={index}>
                              <Autocomplete
                                options={filteredProductMaterials}
                                getOptionLabel={(option) => option.name || ""}
                                value={
                                  filteredProductMaterials.find((option) => option.product_id === mat.name) || null
                                }
                                onChange={(e, newValue) =>
                                  handleMaterialChange(index, "name", newValue ? newValue.product_id : "")
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select a material"
                                    className={styles.materialInput}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                  />
                                )}
                              />
                            </div>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <TextField
                              type="number"
                              value={mat.quantity}
                              onChange={(e) => handleMaterialChange(index, "quantity", e.target.value)}
                              placeholder="0"
                              className={styles.materialInput}
                              variant="outlined"
                              size="small"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <TextField
                              type="number"
                              value={mat.amount}
                              className={styles.materialInput}
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                              // helperText="Auto-filled from material price"
                              sx={{
                                "& .MuiInputBase-input": {
                                  backgroundColor: "#f5f5f5",
                                  cursor: "not-allowed",
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                              ₦{mat.total.toLocaleString()}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <IconButton
                              onClick={() => handleDeleteMaterial(index)}
                              className={styles.deleteButton}
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {/* Summary */}
                  <Box className={styles.summary}>
                    <Box>
                      <Typography className={styles.summaryText}>Total Material Cost</Typography>
                      <Typography className={styles.totalCost}>₦{totalMaterialCost.toLocaleString()}</Typography>
                    </Box>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={handleSubmit}
                      className={styles.submitButton}
                      size="large"
                    >
                      Submit BOM
                    </Button>
                  </Box>
                </Box>
              )}
            </CardContent>
          </Card>

          {/* Branch Selection Dialog */}
          <Dialog open={isBranchDialogOpen} onClose={() => setIsBranchDialogOpen(false)}>
            <DialogTitle>Process Production Requisition</DialogTitle>
            <DialogContent>
              <DialogContentText sx={{ mb: 2 }}>
                Please select a branch to send this production requisition to. This will generate a request for all the
                materials listed in the BOM.
              </DialogContentText>
              <FormControl fullWidth>
                <InputLabel id="branch-select-label">Branch</InputLabel>
                <Select
                  labelId="branch-select-label"
                  id="branch-select"
                  value={selectedBranch}
                  label="Branch"
                  onChange={(e) => setSelectedBranch(e.target.value as string)}
                >
                  {branches?.map((branch) => (
                    <MenuItem key={branch.id} value={branch.branch_id}>
                      {branch.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsBranchDialogOpen(false)}>Cancel</Button>
                <Button
      onClick={handleSendAllRequisitions}
      disabled={!selectedBranch || loading} // disable if branch not selected or loading
      variant="contained"
      startIcon={loading && <CircularProgress size={20} color="inherit" />}
    >
      {loading ? "Producing products..." : "Submit Requisition"}
    </Button>
            </DialogActions>
          </Dialog>

          {/* Notifications */}
          <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
            <Alert onClose={() => setSuccess(false)} severity="success" variant="filled">
              BOM submitted successfully!
            </Alert>
          </Snackbar>
          <Snackbar
            open={!!error}
            autoHideDuration={6000}
            onClose={() => setError(null)}
            sx={{
              position: "sticky",
              bottom: 16,
              left: "50%",
              zIndex: 2400,
            }}
          >
            <Alert onClose={() => setError(null)} severity="error" variant="filled" sx={{ width: "100%" }}>
              {error}
            </Alert>
          </Snackbar>
        </Box>
      </IonContent>
    </IonPage>
  )
}

export default BOMDetailPage
